<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="名称">
        <el-input placeholder="请输入名称" v-model="filter.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="地址">
        <el-input placeholder="请输入地址" v-model="filter.address" clearable></el-input>
      </el-form-item>
      <el-form-item label="是否投运">
        <el-select class="selScale" v-model="filter.is_operation">
          <el-option label="--全部--" value=""> </el-option>
          <el-option label="是" value="true"> </el-option>
          <el-option label="否" value="false"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" highlight-current-row v-loading="loading">
      <el-table-column label="序号" type="index" width="80"></el-table-column>
      <el-table-column label="站点名" prop="name"></el-table-column>
      <el-table-column label="是否投运" prop="status_name" align="center" width="100">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.is_operation">是</el-tag>
          <el-tag type="info" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="所属社区" prop="community_name"></el-table-column>
      <!-- <el-table-column label="建站商户名称" prop="merchant_name"></el-table-column> -->
      <el-table-column label="用电记录分账商户数量" prop="sprofit_partner_num">
        <template slot-scope="{ row }">
          <el-tag type="info" v-if="row.sprofit_partner_num<=0">未设置</el-tag>
          <span type="success" v-else>{{row.sprofit_partner_num}}</span>
        </template>
      </el-table-column>
      <el-table-column label="初装费分账商户数量" prop="sprofit_partner_num"> <template slot-scope="{ row }">
          <el-tag type="info" v-if="row.sprofit_partner_num<=0">未设置</el-tag>
          <span type="success" v-else>{{row.sprofit_partner_num}}</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="380px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">用电记录分账比例设置</el-button>
          <el-button type="text" @click="initFeeRevenueSet(row)" v-permision_tjtf="'edit'">初装费分账设置</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 分账设置 Drawer（用电记录分账 / 初装费分账） -->
    <el-drawer
      :title="drawerTitle"
      :visible.sync="visible.setRatio"
      direction="rtl"
      :size="drawerSize"
      :wrapper-closable="false"
      @closed="onDrawerClosed"
    >
      <div class="drawer-container">
        <div class="drawer-body">
          <!-- 上半部分：站点信息 -->
          <div class="site-info-panel">
            <div class="panel-title">站点信息</div>
            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="站点名">{{ currentSite.name }}</el-descriptions-item>
              <el-descriptions-item label="是否投运">
                <el-tag size="mini" :type="currentSite.is_operation ? 'success' : 'info'">
                  {{ currentSite.is_operation ? "是" : "否" }}
                </el-tag>
              </el-descriptions-item>
              <el-descriptions-item label="所属社区">{{ currentSite.community_name || "-" }}</el-descriptions-item>
              <!-- <el-descriptions-item label="建站商户名称">{{ currentSite.merchant_name || "-" }}</el-descriptions-item> -->
              <el-descriptions-item label="创建时间">{{ currentSite.create_time || "-" }}</el-descriptions-item>
              <el-descriptions-item v-if="isInstallFee" label="初装费总额">
                {{ installFeeTotal > 0 ? installFeeTotal + " 元" : "-" }}
              </el-descriptions-item>
              <el-descriptions-item label="分账商户数量">{{ sharingMerchantList.length }}</el-descriptions-item>
            </el-descriptions>
          </div>

          <!-- 下半部分：分账商户设置 -->
          <div class="ratio-panel">
            <div class="ratio-panel-header">
              <span class="panel-title">分账商户</span>
              <el-button type="primary" size="small" icon="el-icon-plus" @click="onOpenMerchantDialog">添加</el-button>
            </div>

            <div class="ratio-table">
              <el-table ref="ratioTable" :data="sharingMerchantList" border size="small" height="100%" v-loading="ratioLoading">
                <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
                <el-table-column label="商户名称" prop="name" min-width="160" show-overflow-tooltip></el-table-column>
                <!-- 初装费分账才有分账方式 -->
                <el-table-column v-if="isInstallFee" label="分账方式" width="140" align="center">
                  <template slot-scope="{ row }">
                    <el-select v-model="row.share_mode" size="small" @change="onShareModeChange(row)">
                      <el-option label="按比例分账" value="ratio"></el-option>
                      <el-option label="按金额分账" value="amount"></el-option>
                      <el-option label="分剩余" value="remainder"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column :label="isInstallFee ? '分账比例 / 分账金额' : '分账比例'" width="180" align="center">
                  <template slot-scope="{ row }">
                    <!-- 初装费 + 分剩余：分账金额固定为 0，不可修改 -->
                    <el-input v-if="isInstallFee && row.share_mode === 'remainder'" value="0" disabled size="small">
                      <template slot="append">元</template>
                    </el-input>
                    <!-- 初装费 + 按金额分账：输入分账金额（元） -->
                    <el-input
                      v-else-if="isInstallFee && row.share_mode === 'amount'"
                      v-model="row.amount"
                      size="small"
                      placeholder="请输入"
                      @input="onAmountInput(row)"
                    >
                      <template slot="append">元</template>
                    </el-input>
                    <!-- 其余情况：输入分账比例（%） -->
                    <el-input
                      v-else
                      v-model="row.ratio"
                      size="small"
                      placeholder="请输入"
                      :class="{ 'is-invalid': isRatioInvalid(row) }"
                      @input="onRatioInput(row)"
                    >
                      <template slot="append">%</template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="分账开始时间" width="200" align="center">
                  <template slot-scope="{ row }">
                    <el-date-picker
                      v-model="row.start_time"
                      type="datetime"
                      size="small"
                      placeholder="请选择分账开始时间"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 100%"
                    ></el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="90" align="center">
                  <template slot-scope="{ row }">
                    <el-button type="text" class="delete-btn" @click="onRemoveSharingMerchant(row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div
              class="ratio-total"
              :class="{
                'is-over': isInstallFee ? (installFeeTotal > 0 && totalSharingAmount > installFeeTotal) : ratioTotal > 100
              }"
            >
              <template v-if="isInstallFee">
                总的分账金额：{{ totalSharingAmount }} 元
                <span v-if="installFeeTotal > 0">（初装费总额：{{ installFeeTotal }} 元，按比例分账金额 = 初装费总额 × 比例）</span>
              </template>
              <template v-else>
                已设置分账比例合计：{{ ratioTotal }}%，最多不超过 100%
              </template>
            </div>
          </div>
        </div>

        <div class="drawer-footer">
          <el-button @click="visible.setRatio = false">取消</el-button>
          <el-button type="primary" :loading="saving" @click="onSaveRatio">保存</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 选择分账商户 Dialog -->
    <el-dialog
      title="选择商户"
      :visible.sync="visible.selectMerchant"
      width="900px"
      append-to-body
      :close-on-click-modal="false"
      @closed="onMerchantDialogClosed"
    >
      <el-form :inline="true" size="small" @keyup.enter.native="searchMerchant()">
        <el-form-item label="商户名称">
          <el-input
            v-model="merchantFilter.name"
            placeholder="请输入商户名称"
            clearable
            style="width: 200px;"
            @clear="searchMerchant()"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="searchMerchant()">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="merchantTable"
        :data="merchantTableData"
        height="360"
        border
        size="small"
        row-key="ID"
        v-loading="merchantLoading"
        @selection-change="onMerchantSelectionChange"
      >
        <el-table-column type="selection" width="50" reserve-selection :selectable="isMerchantSelectable"></el-table-column>
        <el-table-column label="序号" type="index" width="70" align="center"></el-table-column>
        <el-table-column label="商户名称" prop="name" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="扫码富分账收款方" prop="SaccPayeeCode_Name" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="法人" prop="legal_person" width="100" align="center"></el-table-column>
        <el-table-column label="联系电话" prop="legal_phone" width="130" align="center"></el-table-column>
        <el-table-column label="联系人" prop="link_person" width="100" align="center"></el-table-column>
        <el-table-column label="创建时间" prop="create_date" width="160" align="center"></el-table-column>
      </el-table>

      <div class="my-pagination">
        <el-pagination
          background
          layout="sizes,total,prev,pager,next,jumper"
          :total="merchantPage.total"
          :page-size="merchantPage.limit"
          :page-sizes="[5, 10, 50, 100]"
          :current-page="merchantPage.page"
          @size-change="onMerchantSizeChange"
          @current-change="onMerchantCurrentChange"
        ></el-pagination>
      </div>

      <span slot="footer">
        <el-button @click="visible.selectMerchant = false">取消</el-button>
        <el-button type="primary" @click="onConfirmSelectMerchant">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { getPowerSiteList,  getCommunityList } from "@/api/dev_archive"
import { GetMerchantPageList } from "@/api/dev_data_view"
import {
  // 用电记录分账（SitePartner/GetSitePartnersBySiteId、SitePartner/Save）
  GetSiteSharingMerchantRatio,
  SaveSiteSharingMerchantRatio,
  // 初装费分账（SitePartner/GetSitePartnersInitFeeBySiteId、SitePartner/SaveInitFee）
  GetSitePartnersInitFeeBySiteId,
  SaveInitFeeSiteSharingMerchantRatio
} from "@/api/finance"
import { mapGetters } from "vuex"

export default {
  name: "RevenueSharingRatioSet",
  mixins: [pageMixin],
  data() {
    return {
      
      tableData: [],
      
      filter: {
        name: "",
        address: "",
        is_operation: ""
      },
      loading: false,

      // 弹窗/Drawer 显示控制
      visible: {
        setRatio: false,
        selectMerchant: false
      },
      // 分账设置 Drawer（electric=用电记录分账、install=初装费分账）
      ratioType: "electric",
      drawerSize: "50%",
      currentSite: {},
      sharingMerchantList: [],
      ratioLoading: false,
      saving: false,
      // 选择商户 Dialog
      merchantFilter: {
        name: ""
      },
      merchantTableData: [],
      merchantSelected: [],
      merchantLoading: false,
      merchantPage: {
        page: 1,
        limit: 10,
        total: 0
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    // 是否初装费分账设置
    isInstallFee() {
      return this.ratioType === "install"
    },
    // Drawer 标题
    drawerTitle() {
      return this.isInstallFee ? "初装费分账设置" : "分账比例设置"
    },
    // 初装费总额（用于按比例分账换算金额，兼容后端可能的字段名）
    installFeeTotal() {
      const site = this.currentSite || {}
      const candidates = [
        site.init_fee_total,
        site.install_fee_total,
        site.total_init_fee,
        site.init_fee,
        site.install_fee
      ]
      for (let i = 0; i < candidates.length; i++) {
        const num = Number(candidates[i])
        if (!isNaN(num) && num > 0) return num
      }
      return 0
    },
    // 已设置的分账比例合计
    ratioTotal() {
      const total = this.sharingMerchantList.reduce((sum, item) => {
        const num = Number(item.ratio)
        return sum + (isNaN(num) ? 0 : num)
      }, 0)
      return Math.round(total * 100) / 100
    },
    // 初装费分账：总的分账金额（按金额分账直接累加，按比例分账 = 初装费总额 × 比例）
    totalSharingAmount() {
      const total = this.sharingMerchantList.reduce((sum, item) => {
        if (item.share_mode === "amount") {
          const amount = Number(item.amount)
          return sum + (isNaN(amount) ? 0 : amount)
        }
        const ratio = Number(item.ratio)
        return sum + (isNaN(ratio) ? 0 : ratio) * this.installFeeTotal / 100
      }, 0)
      return Math.round(total * 100) / 100
    }
  },
  created() {
    this.loadCommunityOptions().then(() => {
      this.getData()
    })
  },
  methods: {
    getFirstImageUrl(picJsonString) {
      if (!picJsonString) return null

      try {
        if (picJsonString.startsWith("[") || picJsonString.startsWith("{")) {
          const picArray = JSON.parse(picJsonString)
          if (Array.isArray(picArray)) {
            const validPics = picArray.filter((pic) => pic.path && pic.path.trim() !== "")
            if (validPics.length > 0) {
              return validPics[0].path
            }
          }
        } else {
          const urls = picJsonString
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          if (urls.length > 0) {
            return urls[0].trim()
          }
        }
        return null
      } catch (error) {
        const urls = picJsonString
          .replace(/^,|,$/g, "")
          .split(",")
          .filter((url) => url.trim() !== "")
        if (urls.length > 0) {
          return urls[0].trim()
        }
        return null
      }
    },

    getAllImageUrls(picJsonString) {
      if (!picJsonString) return []

      try {
        if (picJsonString.startsWith("[") || picJsonString.startsWith("{")) {
          const picArray = JSON.parse(picJsonString)
          if (Array.isArray(picArray)) {
            return picArray.filter((pic) => pic.path && pic.path.trim() !== "").map((pic) => pic.path)
          }
        } else {
          const urls = picJsonString
            .replace(/^,|,$/g, "")
            .split(",")
            .filter((url) => url.trim() !== "")
          return urls.map((url) => url.trim())
        }
        return []
      } catch (error) {
        const urls = picJsonString
          .replace(/^,|,$/g, "")
          .split(",")
          .filter((url) => url.trim() !== "")
        return urls.map((url) => url.trim())
      }
    },

    loadCommunityOptions() {
      return getCommunityList()
        .then((res) => {
          if (res && res.data) {
            this.communityOptions = res.data.filter((item) => !item.del)
            return this.communityOptions
          }
          return []
        })
        .catch(() => {
          this.$message.error("加载社区列表失败")
          return []
        })
    },


    getData() {
      this.loading = true
      getPowerSiteList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        ...this.filter
      })
        .then((res) => {
          const communityMap = {}
          this.communityOptions.forEach((community) => {
            communityMap[community.ID] = community.name
          })

          this.tableData = res.data.map((item) => {
            return {
              ...item,
              community_name: communityMap[item.community_id] || item.community_id
            }
          })
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    // 用电记录分账比例设置
    onUpdate(rowData) {
      this.openRatioDrawer(rowData, "electric")
    },

    // 初装费分账设置
    initFeeRevenueSet(rowData) {
      this.openRatioDrawer(rowData, "install")
    },

    // 打开分账设置 Drawer（type：electric=用电记录分账、install=初装费分账）
    openRatioDrawer(site, type) {
      this.ratioType = type
      this.currentSite = { ...site }
      this.sharingMerchantList = []
      this.drawerSize = this.calcDrawerSize()
      this.visible.setRatio = true
      // Drawer 显示后请求该站点已设置的分账商户列表
      this.fetchSiteRatio(site, type)
    },

    // Drawer 宽度 = 内容界面宽度的 50%
    calcDrawerSize() {
      const contentWidth = (this.$el && this.$el.clientWidth) || window.innerWidth
      return Math.max(Math.floor(contentWidth * 0.5), 320) + "px"
    },

    // 请求该站点已设置的分账商户列表
    // 用电记录分账：SitePartner/GetSitePartnersBySiteId；初装费分账：SitePartner/GetSitePartnersInitFeeBySiteId
    fetchSiteRatio(site, type) {
      this.ratioLoading = true
      const api = type === "install" ? GetSitePartnersInitFeeBySiteId : GetSiteSharingMerchantRatio
      api({ site_id: site.ID })
        .then((res) => {
          const list = (res && res.data) || []
          this.sharingMerchantList = list.map((item) => this.normalizeMerchantRow(item, type))
        })
        .catch(() => {
          // 接口异常提示由请求拦截器统一处理
          this.sharingMerchantList = []
        })
        .finally(() => {
          this.ratioLoading = false
          // 数据加载完成后重算表格高度
          this.$nextTick(() => {
            if (this.$refs.ratioTable) {
              this.$refs.ratioTable.doLayout()
            }
          })
        })
    },

    // 统一接口返回的分账商户数据格式
    // 服务端字段：{ ID, power_site_id, merchant_id, share_profit, share_type, create_time, start_time, merchant_name }
    // share_profit：分账比例（0~1，存库 95% 存 0.95），按金额分账时为分账金额，分剩余固定为 0
    // share_type：初装费分账方式，0 按比例、1 按金额、2 分剩余
    normalizeMerchantRow(item, type) {
      const isInstallFee = type === "install"
      const shareProfit = item.share_profit != null ? Number(item.share_profit) : 0
      let shareMode = "ratio"
      if (isInstallFee) {
        const shareType = Number(item.share_type)
        if (shareType === 1) shareMode = "amount"
        else if (shareType === 2) shareMode = "remainder"
      }
      return {
        ID: item.merchant_id != null ? item.merchant_id : item.ID,
        name: item.merchant_name || item.name,
        // 分账方式：ratio=按比例分账、amount=按金额分账、remainder=分剩余（后两者仅初装费分账使用）
        share_mode: shareMode,
        // 按比例分账：把 share_profit(0~1) 换算成百分比展示
        ratio: shareMode === "ratio" ? Math.round(shareProfit * 100 * 100) / 100 : 0,
        // 按金额分账：share_profit 即分账金额（元）；分剩余固定为 0
        amount: shareMode === "amount" ? shareProfit : 0,
        // 分账开始时间（保存时原样回传；服务端未设置或值无效时默认当前时间）
        start_time: this.getStartTime(item)
      }
    },

    onDrawerClosed() {
      this.currentSite = {}
      this.sharingMerchantList = []
      this.ratioLoading = false
      this.ratioType = "electric"
    },

    // 限制分账比例输入：只允许数字，最多两位小数
    onRatioInput(row) {
      let val = row.ratio === null || row.ratio === undefined ? "" : String(row.ratio)
      val = val.replace(/[^\d.]/g, "").replace(/^\./, "").replace(/\.{2,}/g, ".")
      const parts = val.split(".")
      if (parts.length > 1) {
        val = parts[0] + "." + parts[1].slice(0, 2)
      }
      if (val.length > 1 && val[0] === "0" && val[1] !== ".") {
        val = val.replace(/^0+/, "")
      }
      row.ratio = val
    },

    isRatioInvalid(row) {
      if (row.ratio === "" || row.ratio === null || row.ratio === undefined) return false
      const num = Number(row.ratio)
      return isNaN(num) || num < 0 || num > 100
    },

    // 限制分账金额输入：只允许数字，最多两位小数
    onAmountInput(row) {
      let val = row.amount === null || row.amount === undefined ? "" : String(row.amount)
      val = val.replace(/[^\d.]/g, "").replace(/^\./, "").replace(/\.{2,}/g, ".")
      const parts = val.split(".")
      if (parts.length > 1) {
        val = parts[0] + "." + parts[1].slice(0, 2)
      }
      row.amount = val
    },

    // 切换分账方式（按金额分账时初始化金额，分剩余金额固定为 0，按比例分账时初始化比例）
    onShareModeChange(row) {
      if (row.share_mode === "amount") {
        if (row.amount === "" || row.amount === null || row.amount === undefined) {
          row.amount = 0
        }
      } else if (row.share_mode === "remainder") {
        // 分剩余：分账金额固定为 0，不可修改
        row.amount = 0
      } else if (row.ratio === "" || row.ratio === null || row.ratio === undefined) {
        row.ratio = 0
      }
    },

    onRemoveSharingMerchant(row) {
      this.$confirm(`确定要删除商户「${row.name}」的分账设置吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const index = this.sharingMerchantList.findIndex((item) => item.ID === row.ID)
          if (index > -1) {
            this.sharingMerchantList.splice(index, 1)
          }
          //this.$message.success("删除成功")
        })
        .catch(() => {})
    },

    /* ============ 选择商户 Dialog ============ */
    onOpenMerchantDialog() {
      this.visible.selectMerchant = true
      this.merchantFilter.name = ""
      this.merchantSelected = []
      this.searchMerchant()
    },

    searchMerchant(resetPage = true) {
      if (resetPage) this.merchantPage.page = 1
      this.merchantLoading = true
      GetMerchantPageList({
        page: this.merchantPage.page,
        pagesize: this.merchantPage.limit,
        name: this.merchantFilter.name || null,
        site_id: this.currentSite.ID
      })
        .then((res) => {
          this.merchantTableData = (res && res.data) || []
          this.merchantPage.total = (res && (res.total || res.count)) || 0
          // Dialog 显示后重算表格高度
          this.$nextTick(() => {
            if (this.$refs.merchantTable) {
              this.$refs.merchantTable.doLayout()
            }
          })
        })
        .catch(() => {})
        .finally(() => {
          this.merchantLoading = false
        })
    },

    onMerchantSizeChange(val) {
      this.merchantPage.limit = val
      this.searchMerchant()
    },

    onMerchantCurrentChange(val) {
      this.merchantPage.page = val
      this.searchMerchant(false)
    },

    onMerchantSelectionChange(rows) {
      this.merchantSelected = rows
    },

    // 已添加的商户不允许重复选择
    isMerchantSelectable(row) {
      return !this.sharingMerchantList.some((item) => item.ID === row.ID)
    },

    onConfirmSelectMerchant() {
      if (!this.merchantSelected.length) {
        this.$message.warning("请先选择商户")
        return
      }
      let addedCount = 0
      this.merchantSelected.forEach((row) => {
        if (!this.sharingMerchantList.some((item) => item.ID === row.ID)) {
          this.sharingMerchantList.push({
            ID: row.ID,
            name: row.name,
            legal_person: row.legal_person,
            legal_phone: row.legal_phone,
            link_person: row.link_person,
            create_date: row.create_date,
            // 新添加的商户默认按比例分账，分账比例与分账金额默认为 0
            share_mode: "ratio",
            ratio: 0,
            amount: 0,
            // 分账开始时间默认当前时间
            start_time: this.getCurrentDateTime()
          })
          addedCount++
        }
      })
      if (!addedCount) {
        this.$message.warning("所选商户已存在，请勿重复添加")
      } else {
        this.$message.success(`已添加${addedCount}个分账商户`)
      }
      this.visible.selectMerchant = false
    },

    onMerchantDialogClosed() {
      this.merchantSelected = []
      if (this.$refs.merchantTable) {
        this.$refs.merchantTable.clearSelection()
      }
    },

    /* ============ 保存分账设置 ============ */
    onSaveRatio() {
      if (!this.sharingMerchantList.length) {
        this.$message.warning("请先添加分账商户")
        return
      }
      // 校验每个商户的分账设置
      for (const item of this.sharingMerchantList) {
        // 校验分账开始时间
        if (!item.start_time) {
          this.$message.warning(`请选择「${item.name}」的分账开始时间`)
          return
        }
        // 初装费分账 + 分剩余：分账金额固定为 0，无需校验
        if (this.isInstallFee && item.share_mode === "remainder") {
          item.amount = 0
          continue
        }
        // 初装费分账 + 按金额分账：校验分账金额
        if (this.isInstallFee && item.share_mode === "amount") {
          if (item.amount === "" || item.amount === null || item.amount === undefined) {
            this.$message.warning(`请输入「${item.name}」的分账金额`)
            return
          }
          const amount = Number(item.amount)
          if (isNaN(amount) || amount < 0) {
            this.$message.warning(`「${item.name}」的分账金额需为大于等于0的数字`)
            return
          }
          continue
        }
        // 按比例分账：校验分账比例
        if (item.ratio === "" || item.ratio === null || item.ratio === undefined) {
          this.$message.warning(`请输入「${item.name}」的分账比例`)
          return
        }
        const num = Number(item.ratio)
        if (isNaN(num) || num < 0 || num > 100) {
          this.$message.warning(`「${item.name}」的分账比例需为0~100之间的数字`)
          return
        }
      }

      if (this.isInstallFee) {
        // 初装费分账方式：ratio 按比例分账、amount 按金额分账、remainder 分剩余
        const hasRatio = this.sharingMerchantList.some((item) => item.share_mode === "ratio")
        const hasAmount = this.sharingMerchantList.some((item) => item.share_mode === "amount")
        const hasRemainder = this.sharingMerchantList.some((item) => item.share_mode === "remainder")

        // 按比例分账 与 按金额分账（含分剩余）不可共存
        if (hasRatio && (hasAmount || hasRemainder)) {
          this.$message.warning("按比例分账不可与按金额分账（含分剩余）同时存在，请统一分账方式")
          return
        }
        // 存在按金额分账的商户时，必须至少有一个分剩余的商户
        if (hasAmount && !hasRemainder) {
          this.$message.warning("存在按金额分账的商户时，必须至少有一个分剩余的商户")
          return
        }
        // 只有按比例分账时，所有商户分账比例之和必须为100%
        if (!hasAmount && !hasRemainder && Math.abs(this.ratioTotal - 100) > 0.000001) {
          this.$message.warning(`所有商户分账比例之和必须为100%，当前合计${this.ratioTotal}%`)
          return
        }
        // 校验总的分账金额不超过初装费总额
        /* if (this.installFeeTotal > 0 && this.totalSharingAmount > this.installFeeTotal) {
          this.$message.warning(
            `总的分账金额不能超过初装费总额${this.installFeeTotal}元，当前合计${this.totalSharingAmount}元`
          )
          return
        } */
      } else if (Math.abs(this.ratioTotal - 100) > 0.000001) {
        // 用电记录分账：服务端要求所有商户分账比例之和必须为100%
        this.$message.warning(`所有商户分账比例之和必须为100%，当前合计${this.ratioTotal}%`)
        return
      }

      // 组装请求参数（服务端接收的是分账商户数组）
      const list = this.sharingMerchantList.map((item) => {
        const isAmountMode = this.isInstallFee && item.share_mode === "amount"
        const isRemainderMode = this.isInstallFee && item.share_mode === "remainder"
        // 分账比例：按比例分账存 0~1 的比例（如 95% 存 0.95）；按金额分账存分账金额；分剩余固定为 0
        let shareProfit = Math.round(Number(item.ratio) * 100) / 10000
        if (isAmountMode) {
          shareProfit = Number(item.amount)
        } else if (isRemainderMode) {
          shareProfit = 0.1
        }
        const row = {
          power_site_id: this.currentSite.ID,
          merchant_id: item.ID,
          share_profit: shareProfit,
          // 分账开始时间：沿用服务端返回的值，新增的商户取当前时间
          start_time: this.getStartTime(item)
        }
        if (this.isInstallFee) {
          // 初装费分账方式：0 按比例、1 按金额、2 分剩余
          if (isAmountMode) {
            row.share_type = 1
          } else if (isRemainderMode) {
            row.share_type = 2
          } else {
            row.share_type = 0
          }
        }
        return row
      })

      // 用电记录分账：SitePartner/Save；初装费分账：SitePartner/SaveInitFee
      const api = this.isInstallFee ? SaveInitFeeSiteSharingMerchantRatio : SaveSiteSharingMerchantRatio
      this.saving = true
      api(list)
        .then(() => {
          this.$message.success("保存成功")
          this.visible.setRatio = false
        })
        .catch(() => {
          // 校验失败信息（如比例之和不符要求）由请求拦截器统一弹出
        })
        .finally(() => {
          this.saving = false
        })
    },

    // 分账开始时间：沿用服务端返回的值，缺失或值无效时默认当前时间
    getStartTime(item) {
      const startTime = item && item.start_time
      if (startTime && !String(startTime).startsWith("0001-01-01")) {
        return startTime
      }
      return this.getCurrentDateTime()
    },

    // 当前时间（yyyy-MM-dd HH:mm:ss）
    getCurrentDateTime() {
      return this.formatDateTime(new Date())
    },

    // 格式化日期时间：yyyy-MM-dd HH:mm:ss
    formatDateTime(date) {
      const pad = (num) => (num < 10 ? `0${num}` : `${num}`)
      return (
        `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
        `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
      )
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

.station-img {
  width: 50px;
  height: 50px;
}

/* ============ 分账比例设置 Drawer ============ */
.drawer-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.drawer-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 12px 20px 0;
}

.site-info-panel {
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}

.ratio-panel {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
}

.ratio-panel-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.ratio-panel-header .panel-title {
  margin-bottom: 0;
}

.ratio-table {
  flex: 1;
  min-height: 0;
}

.ratio-total {
  flex-shrink: 0;
  margin: 10px 0 14px;
  padding: 10px 14px;
  border-radius: 4px;
  background-color: #f5f7fa;
  font-size: 13px;
  line-height: 22px;
  text-align: right;
  color: #909399;
  letter-spacing: 0.5px;
}

.ratio-total.is-over {
  color: #f56c6c;
  background-color: #fef0f0;
  font-weight: 600;
}

.drawer-footer {
  flex-shrink: 0;
  padding: 12px 20px;
  border-top: 1px solid #ebeef5;
  text-align: right;
}

.delete-btn {
  color: #f56c6c;
}

::v-deep .el-drawer__body {
  overflow: hidden;
}

/* 分账比例输入框尾部的 % 符号 */
::v-deep .el-input-group__append {
  padding: 0 10px;
}

/* 分账比例超出 0~100 时的提示样式 */
::v-deep .is-invalid .el-input__inner {
  border-color: #f56c6c;
}
</style>
